import http from "./http-common"

class ConsentService {
    queryString(payload) {
        return Object.keys(payload)
            .map((key) => (key && payload[key])? key + "=" + payload[key]:'')
            .join("&");
    }
    
    GetPatientConsent(payload) {
        return http.post(`/PatientConsentDetails/send-patient-consent`,payload);
    }

}

export default new ConsentService();